import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { SessionService } from '../../shared/services/session.service';
import { Router } from '@angular/router';
import { Base } from '../../shared/utils/base';

@Injectable({
  providedIn: 'root',
})
export class RootGuard extends Base implements CanActivate {
  constructor(private _session: SessionService, private _router: Router) {
    super();
  }

  public canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {

    //Check if tokens are complete
    if(this.storage.token()===null || this.storage.role()===null || this.storage.subsStatus()===null){
        this.storage.removeToken();
      }


    if (this._session.isLoggedIn()) {
      if (this.storage.getRole() === 'customer' || this.storage.getRole() === 'subscriber') {
        this._router.navigate(['/proyectos/lista']);
        return false;
      }

      if (this.storage.getRole() === 'budgetsadmin' || this.storage.getRole() === 'budgetsadmintest') {
        this._router.navigate(['/admin/catalogos/lista']);
        return false;
      } else {        
        return false;
      }
    } else {
    //   this._router.navigate(['/iniciar-sesion']);
      return true;
    }
  }
}
